import { render } from "./ConsentVersionForm.vue?vue&type=template&id=bfcce784&ts=true"
import script from "./ConsentVersionForm.vue?vue&type=script&lang=ts"
export * from "./ConsentVersionForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Consents/ConsentVersionForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bfcce784"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bfcce784', __exports__)) {
    api.reload('bfcce784', __exports__)
  }
  
  module.hot.accept("./ConsentVersionForm.vue?vue&type=template&id=bfcce784&ts=true", () => {
    api.rerender('bfcce784', render)
  })

}


export default __exports__